import { type ADFDocument } from '@canvas/adf-types';

import { plainTextToAdf } from './conversions';
import { emptyADFContent } from './empty';

export function resolveRichTextValue(value: {
  plain?: string;
  rich?: ADFDocument;
}): ADFDocument {
  if (value.rich?.content && value.rich.content.length > 0) {
    return value.rich;
  }
  return (value.plain?.trim() ?? '') !== ''
    ? plainTextToAdf(value.plain ?? '')
    : emptyADFContent;
}
